export default function isStringTuple(tuple) {
    const [one, two] = tuple;
    return typeof one === 'string' && typeof two === 'string';
}
//# sourceMappingURL=is-string-tuple.js.map